import {
  EMPLOYEEWARNING_LOADING,
  GET_EMPLOYEEWARNING,
  GET_EMPLOYEEWARNING_SUCCESS,
  GET_EMPLOYEEWARNING_FAIL,
  ADD_EMPLOYEEWARNING_SUCCESS,
  ADD_EMPLOYEEWARNING_FAIL,
  DELETE_EMPLOYEEWARNING_SUCCESS,
  DELETE_EMPLOYEEWARNING_FAIL,
  UPDATE_EMPLOYEEWARNING_SUCCESS,
  UPDATE_EMPLOYEEWARNING_FAIL,
  EMPLOYEEWARNING_RESET
} from "./actionType";

const INIT_STATE = {
  employeeWarnings: [],
  error: {},
};

const EmployeeWarning = (state = INIT_STATE, action) => {
  switch (action.type) {
    case GET_EMPLOYEEWARNING_SUCCESS:
      switch (action.payload.actionType) {
        case GET_EMPLOYEEWARNING:
          return {
            ...state,
            employeeWarnings: action.payload.data,
            isEmployeeWarningCreated: false,
            isEmployeeWarningSuccess: true,
            loading: false,
          };

        default:
          return { ...state };
      }
    case GET_EMPLOYEEWARNING_FAIL:
      switch (action.payload.actionType) {
        case GET_EMPLOYEEWARNING_FAIL:
          return {
            ...state,
            error: action.payload.error,
            isEmployeeWarningCreated: false,
            isEmployeeWarningSuccess: false,
            loading: false,
          };
        default:
          return { ...state };
      }

    case GET_EMPLOYEEWARNING: {
      return {
        ...state,
        isEmployeeWarningCreated: false,
        loading: true,
      };
    }

    case EMPLOYEEWARNING_LOADING: {
      return {
        ...state,
        isEmployeeWarningCreated: false,
        loading: true,
      };
    }

    case ADD_EMPLOYEEWARNING_SUCCESS:
      return {
        ...state,
        isEmployeeWarningCreated: true,
        loading: false,
        employeeWarnings: [action.payload.data, ...state.employeeWarnings],
      };

    case ADD_EMPLOYEEWARNING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case DELETE_EMPLOYEEWARNING_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeWarnings: state.employeeWarnings.filter(
          employeeWarning => employeeWarning.id.toString() !== action.payload.id.toString()
        ),
      };

    case DELETE_EMPLOYEEWARNING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case UPDATE_EMPLOYEEWARNING_SUCCESS:
      return {
        ...state,
        loading: false,
        employeeWarnings: state.employeeWarnings.map(employeeWarning =>
          employeeWarning.id.toString() === action.payload.data.id.toString() ? { ...employeeWarning, ...action.payload.data } : employeeWarning
        ),
      };

    case UPDATE_EMPLOYEEWARNING_FAIL:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    case EMPLOYEEWARNING_RESET:
      return INIT_STATE;

    default:
      return { ...state };
  }
};

export default EmployeeWarning;